/**
 * On-demand publish: every internal song's `urlOnline` points at a
 * deterministic CDN master.m3u8 URL — the API hands us the exact URL to
 * poll (see `libs/wire/src/types/song.ts`), the client never constructs or
 * assumes a CDN path convention. For brand-new content, that URL may 404
 * until the worker finishes transcoding (it may already fire a publish
 * intent server-side when the surrounding album/song was loaded); for
 * already-materialized content it's a normal 200 on the very first check.
 * `ensureSongPlayable` polls this URL before every play, uniformly, with
 * no branching on any special status — see its doc comment.
 */
export const ON_DEMAND_POLL_INTERVAL_MS = 50;
export const ON_DEMAND_POLL_TIMEOUT_MS = 10_000;
